module.exports = __webpack_public_path__ + "images/speed-one-default.823d86c0aede2f4a66d38738bb457cc8.png";